/*
 * @Description:
 * @Date: 2022-04-19 16:03:38
 */
import { ref, nextTick } from 'vue';
import { defineStore } from 'pinia';
import { removeEmpty } from '@/utils/formatter';
import { RouteQuery } from '../types/index';

export const useProjectManageStore = defineStore(
  'projectManageStore',
  () => {
    const routeQuery = ref<RouteQuery>(null);
    const setRouteQuery = (data, cb?) => {
      routeQuery.value = removeEmpty(data);

      nextTick(() => {
        cb && cb();
      });
    };
    const initRouteQuery = () => {
      routeQuery.value = null;
    };
    const clearStore = async () => {
      await initRouteQuery();
      nextTick(() => {
        window.sessionStorage.removeItem('projectManageStore');
      });
    };

    return {
      routeQuery,
      setRouteQuery,
      initRouteQuery,
      clearStore
    };
  },
  {
    persist: {
      storage: sessionStorage
    }
  }
);
